import React, { useState } from "react";
import { Footer, Navbar } from "../components";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ShowCart from "./ShowCart";
import axios from "axios";
import configData from "../config.json";
import { addCart, delCart, clrCart } from "../redux/action";

import districts from "../data/bd-districts.json";
import postcodes from "../data/bd-postcodes.json";



const Checkout = () => {
  const [inputData,setInputData]=useState({firstName:'',email:'',passcode:'',mobile:'',address:'',district:'',postcode:'',mop:''})

  const navigate=useNavigate();
  const state = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();

  const [postcode,setpostcode]=useState([]);
  const [districtID,setdistrictID]=useState();
  const [postcodeID,setpostcodeID]=useState();

  const [error, setError] = useState('');

  const handleInput=(e)=>{
    const {name,value}=e.target; 
    setInputData({...inputData,[name]:value});  
  }

  const handleInputMobile=(e)=>{
    const {name,value}=e.target; 

    if(name==='mobile'){
      if (/^\d*$/.test(value)) {
        setInputData({...inputData,[name]:value});
        if(value.length !== 11) {setError('Mobile No. must be 11 digits')} else setError('');
      } 
      else setError('Only bigits are allowed.');
    } 
  }


  const clearCart = () => {
    dispatch(clrCart());
  };

  const handleSubmit=async(e)=>{
    e.preventDefault();

    const allinputData={firstName:inputData.firstName,email:inputData.email,passcode:inputData.passcode,mobile:inputData.mobile,
                        address:inputData.address,district:inputData.district,postcode:inputData.postcode,items:state,mop:inputData.mop}

      let loginData=await axios.post(configData.SERVER_URL+'/loginEntry',allinputData);
      console.log(loginData);
      if(loginData.status===200){
        if(loginData.data.length>0){
          let res=await axios.post(configData.SERVER_URL+'/customerAddressEntry',allinputData);
          if(res.status===200){
            if(res.data.success){
              alert('Successfully Order Posted');
              setTimeout(()=>{
                // window.location.replace('/orderlist/'+allinputData.email);   
                navigate('/orderlist', { state: { email: allinputData.email } });          
              },2000)       
            }     
          } else alert('Insertion Fail');

        } else {alert('Invalid Email or Password');} 
      }  

  }

  const handleDistrict=(e)=>{   
    const getDistrictID=e.target.value;
    setdistrictID(getDistrictID);
    // const getpostcodeData=postcodes.postcodes.find(postcodes=>postcodes.district_id===getDistrictID);
    const getpostcodeData= postcodes.postcodes.filter((postcode) => postcode.district_id === getDistrictID);
    setpostcode(getpostcodeData);

    setInputData({...inputData,[e.target.name]:getDistrictID});
    
  }

  const handlePostcode=(e)=>{
    const getPostcodeID=e.target.value;
    setpostcodeID(getPostcodeID);

    setInputData({...inputData,[e.target.name]:getPostcodeID});
  }

  const EmptyCart = () => {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 py-5 bg-light text-center">
            <h4 className="p-3 display-5">No item in Cart</h4>
            <Link to="/" className="btn btn-outline-dark mx-4">
              <i className="fa fa-arrow-left"></i> Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  };



  // const ShowCheckout = () => {

  //   return (
  //     <>
  //       <div className="row">{< ShowCart />}</div>
  //       <div className="row">
  //           <div className="col-md-7 col-lg-8">
  //             <div className="card mb-4">
  //               <div className="card-header py-3">
  //                 <h4 className="mb-0">Billing address</h4>
  //               </div>
  //               <div className="card-body">
  //                 <form onSubmit={handleSubmit} >
  //                   <div className="row g-3">
  //                     <div className="col-sm-12 my-1">
  //                       <label for="firstName" className="form-label">First name</label>
  //                       <input type="text" className="form-control" id="firstName" name="firstName"  placeholder="" 
  //                       required />
  //                       {/* <div className="invalid-feedback"> Valid first name is required. </div> */}
  //                     </div>

  //                     <div className="col-sm-6 my-1">
  //                       <label for="email" className="form-label"> Email </label>
  //                       <input type="email" className="form-control" id="email" name="email" 
  //                       placeholder="you@example.com" required />
  //                       {/* <div className="invalid-feedback"> Please enter a valid email address for shipping updates.</div> */}
  //                     </div>

  //                     <div className="col-sm-6 my-1">
  //                       <label for="mobile" className="form-label">Mobile</label>
  //                       <input type="text" className="form-control" id="mobile" name="mobile" 
  //                       placeholder="" required />
  //                       {/* <div className="invalid-feedback"> Valid first name is required. </div> */}
  //                     </div>

  //                     <div className="col-12 my-1">
  //                       <label for="address" className="form-label"> Address </label>
  //                       <input type="text" className="form-control" id="address" name="address"
  //                       placeholder="102, Kazinazrul Islam Avinue" required />
  //                       {/* <div className="invalid-feedback"> Please enter your shipping address. </div> */}
  //                     </div>

  //                     {/* <div className="col-md-5 my-1">
  //                       <label for="country" className="form-label"> Country</label>
  //                       <br />
  //                       <select className="form-select" id="country" required>
  //                         <option value="">Choose...</option>
  //                         <option>Bangladesh</option>
  //                       </select>
  //                     </div> */}

  //                     <div className="col-md-4 my-1">
                        
  //                       <label for="district" className="form-label"> District </label>
  //                       <br />
  //                       <select className="form-select" id="district" name="district" onChange={(e)=>handleDistrict(e)} value={districtID} required>
  //                       <option value="">Choose...</option>
  //                       {districts.districts.map((getdistrict)=>(                          
  //                           <option value={getdistrict.id} key={getdistrict.id}>{getdistrict.name}</option>
  //                         ))}
  //                       </select>
  //                       {/* <div className="invalid-feedback">
  //                         Please provide a valid state.
  //                       </div> */}
  //                     </div>

  //                     <div className="col-md-8 my-1">
  //                       <label for="postcode" className="form-label">Post Code</label> 
  //                       {/* <input type="text" className="form-control" id="zip" placeholder="" required /> */}
  //                       <select className="form-select" id="postcode" name="postcode" onChange={(e)=>handlePostcode(e)} value={postcodeID} required>
  //                       <option value="">Choose...</option>
  //                       {postcode.map((getpostcode,index)=>(                          
  //                           <option value={getpostcode.postCode} key={index}>{getpostcode.postCode+':'+getpostcode.postOffice}</option>
  //                         ))}
  //                       </select>
  //                     </div>
  //                   </div>

  //                   <hr className="my-4" />

  //                   <button
  //                     className="w-100 btn btn-primary " type="submit" >Continue to checkout</button>
  //                 </form>
  //               </div>
  //             </div>
  //           </div>
  //       </div>                
  //     </>
  //   );
  // };
  
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Checkout</h1>
        <hr />
        {console.log('state.length='+state.length)}
        {state.length ? 
        <div>
        <div className="row">{< ShowCart />}</div>
        <div className="row">
            <div className="col-md-7 col-lg-8">
              <div className="card mb-4">
                <div className="card-header py-3">
                  <h4 className="mb-0" style={{color:'green'}}>Login & Checkout</h4>
                  {error && <p style={{color:'red'}}>{error}</p>}
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit} >
                    <div className="row g-3">

                    <div className="col-sm-6 my-1">
                        <label for="email" className="form-label"><i style={{color:'red'}}>*</i> Email (Insert Registered Email) </label>
                        <input type="email" className="form-control" id="email" name="email" 
                        value={inputData.email} onChange={(e)=>{handleInput(e)}} placeholder="you@example.com" required />

                        <label for="floatingPassword display-4">Password</label>
                        <input type="password" class="form-control"  id="passcode"  name="passcode"  placeholder="Password" 
                        value={inputData.passcode}
                        onChange={(e)=>{handleInput(e)}} required/>

                        <p>New Here? <Link to="/register" className="text-decoration-underline text-info">Register</Link> </p>
                      </div>

                      <label style={{color:'green'}}>Billing Address</label>
                      <hr/>

                      <div className="col-sm-12 my-1">
                        <label for="firstName" className="form-label"><i style={{color:'red'}}>*</i>Full Name</label>
                        <input type="text" className="form-control" id="firstName" name="firstName"
                        value={inputData.firstName} onChange={(e)=>{handleInput(e)}} placeholder=""  required />
                      </div>

                      

                      <div className="col-sm-6 my-1">
                        <label for="mobile" className="form-label"><i style={{color:'red'}}>*</i>Mobile</label>
                        <input type="text" className="form-control" id="mobile" name="mobile" 
                        value={inputData.mobile} onChange={(e)=>{handleInputMobile(e)}} placeholder="" required />
                      </div>

                      <div className="col-12 my-1">
                        <label for="address" className="form-label"><i style={{color:'red'}}>*</i> Address </label>
                        <input type="text" className="form-control" id="address" name="address"
                        value={inputData.address} onChange={(e)=>{handleInput(e)}} required />
                      </div>

                      <div className="col-md-4 my-1">
                        
                        <label for="district" className="form-label"><i style={{color:'red'}}>*</i> District </label>
                        <br />
                        <select className="form-select" id="district" name="district" onChange={(e)=>handleDistrict(e)} value={districtID} required>
                        <option value="">Choose...</option>
                        {districts.districts.map((getdistrict)=>(                          
                            <option value={getdistrict.id} key={getdistrict.id}>{getdistrict.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-8 my-1">
                        <label for="postcode" className="form-label"><i style={{color:'red'}}>*</i>Post Code</label> 
                        <select className="form-select" id="postcode" name="postcode" onChange={(e)=>handlePostcode(e)} value={postcodeID} required>
                        <option value="">Choose...</option>
                        {postcode.map((getpostcode,index)=>(                          
                            <option value={getpostcode.postCode} key={index}>{getpostcode.postCode+':'+getpostcode.postOffice}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <hr className="my-4" />
                        <label for="address" className="form-label"><i style={{color:'red'}}>*</i> Mode of Payment </label>
                        <select className="form-select" id="mop" name="mop" onChange={(e)=>handleInput(e)} value={inputData.mop} required>
                        <option value="">Choose...</option>                                                  
                          <option value='OP' key='OP'>Online Payment</option>  
                          <option value='CD' key='CD'>Cash on Delivery</option>                        
                        </select>
                    <hr className="my-4" />

                    <button className="w-100 btn btn-primary " type="submit"  >Order Confirm & Payment</button>
                  </form>
                </div>
              </div>
            </div>
        </div>  
        </div>
        : <EmptyCart />}
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
